import { useState, useEffect } from "react";

import { Box } from "@mui/material";
import moment, { Moment } from "moment";

const convertSecondsToHMS = (seconds: number) => {
  const hr = Math.floor(seconds / 3600);
  const min = Math.floor((seconds % 3600) / 60);
  const sec = seconds % 60;
  return { hours: hr, minutes: min, seconds: sec };
};

const LastUpdated = ({ lastUpdatedTime }: { lastUpdatedTime: Moment }) => {
  const [timeElapsed, setTimeElapsed] = useState(
    moment().diff(lastUpdatedTime, "seconds")
  );

  useEffect(() => {
    const interval = setInterval(() => {
      const tmp = moment().diff(lastUpdatedTime, "seconds");
      setTimeElapsed(tmp);
    }, 1000); // update every second

    return () => clearInterval(interval);
  }, [lastUpdatedTime]);

  const { hours, minutes, seconds } = convertSecondsToHMS(timeElapsed);

  const h = hours === 0 ? "" : `${hours}h `;
  const m = minutes === 0 ? "" : `${minutes}m `;
  const lastUpdatedLabel = `${h}${m}${seconds}s`;

  return (
    <Box>
      Last updated: <b>{lastUpdatedLabel}</b>
    </Box>
  );
};

export default LastUpdated;
